"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M38.071 9.928a19.9 19.9 0 1 0 0 28.143 19.9 19.9 0 0 0 0-28.143zm-6.294 23.547a1 1 0 0 1-1.414 0L24 27.111l-6.364 6.364a1 1 0 0 1-1.414 0l-1.7-1.7a1 1 0 0 1 0-1.414L20.888 24l-6.363-6.363a1 1 0 0 1 0-1.414l1.7-1.7a1 1 0 0 1 1.414 0L24 20.888l6.365-6.363a1 1 0 0 1 1.414 0l1.7 1.7a1 1 0 0 1 0 1.414L27.112 24l6.363 6.364a1 1 0 0 1 0 1.414z" })
);

